// extracted by mini-css-extract-plugin
export var chevron = "_lw-2";
export var chevronRotated = "_lw-3";
export var header = "_lw-1";
export var section = "_lw-0";